// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5ec2b6f5","239":"0405c7ed","453":"6e46d562","732":"d7c1ba9d","977":"1242f2b3"}[chunkId] + ".chunk.js";
};